import React from "react";
import { useParams, Link } from "react-router-dom";
import { blogPosts } from "./blogData";
import "./pillarPage.css";

export default function PillarPage() {
  const { pillar } = useParams();
  let pillarName = pillar
    .replace(/-/g, " ")
    .replace(/\b\w/g, (l) => l.toUpperCase());
  // Special case for legal-taxes route
  if (pillar === "legal-taxes") {
    pillarName = "Legal & Taxes";
  }
  const posts = blogPosts.filter(
    (p) => p.pillar.toLowerCase().replace(/ & | /g, "-") === pillar,
  );
  // Optional: Add a short description for each pillar
  const pillarDescriptions = {
    "Market Data":
      "Latest trends, statistics, and insights on Nepal's property rental market.",
    Neighborhoods:
      "Explore rental opportunities, amenities, and living experiences in different areas.",
    Landlords:
      "Guides, tips, and legal advice for property owners and landlords in Nepal.",
    Tenants:
      "Advice, rights, and resources for renters seeking homes in Nepal.",
    "Legal & Taxes":
      "Understand the legal and tax aspects of renting property in Nepal.",
  };
  const desc = pillarDescriptions[pillarName] || "";
  return (
    <div className="pillar-page">
      <h1>{pillarName}</h1>
      {desc && <div className="pillar-desc">{desc}</div>}
      <ul>
        {posts.map((post) => (
          <li key={post.slug}>
            <Link to={`/blog/${post.slug}`}>{post.title}</Link>
            <div className="blog-meta">
              {post.date} | {post.author}
            </div>
            <div className="blog-desc">{post.metaDescription}</div>
          </li>
        ))}
      </ul>
      <Link className="back-link" to="/blog">
        ← Back to Blog Index
      </Link>
    </div>
  );
}
